import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';

export default withStyles({
  root: {
    display: 'block',
  },
})(FormControl);
